export default __webpack_public_path__ + "static/media/5s.91fac24b.svg";